
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as articlesSToQQf8MXRMeta } from "/vercel/path0/pages/articles.vue?macro=true";
import { default as contactJnsDpYVejzMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as historyccFtdcgOm1Meta } from "/vercel/path0/pages/history.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as jobsYEm0IKP6FRMeta } from "/vercel/path0/pages/jobs.vue?macro=true";
import { default as _91slug_93EgnsZjwaosMeta } from "/vercel/path0/pages/particle/[slug].vue?macro=true";
import { default as platformbaJR6KIJ0AMeta } from "/vercel/path0/pages/platform.vue?macro=true";
import { default as privacykJ3SQnmrN4Meta } from "/vercel/path0/pages/privacy.vue?macro=true";
import { default as servicesoiqz5GGY44Meta } from "/vercel/path0/pages/services.vue?macro=true";
import { default as slice_45simulatorXNBTl3WVLzMeta } from "/vercel/path0/pages/slice-simulator.vue?macro=true";
import { default as teamThGqkFwfKIMeta } from "/vercel/path0/pages/team.vue?macro=true";
import { default as testimonials_gwGH7CfSfTMeta } from "/vercel/path0/pages/testimonials_.vue?macro=true";
import { default as testimonialstgkVwUfzpZMeta } from "/vercel/path0/pages/testimonials.vue?macro=true";
export default [
  {
    name: "articles___fr",
    path: "/newsletter",
    component: () => import("/vercel/path0/pages/articles.vue")
  },
  {
    name: "articles___en",
    path: "/en/newsletter",
    component: () => import("/vercel/path0/pages/articles.vue")
  },
  {
    name: "articles___lu",
    path: "/lu/newsletter",
    component: () => import("/vercel/path0/pages/articles.vue")
  },
  {
    name: "contact___fr",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "contact___lu",
    path: "/lu/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "history___fr",
    path: "/a-propos",
    component: () => import("/vercel/path0/pages/history.vue")
  },
  {
    name: "history___en",
    path: "/en/history",
    component: () => import("/vercel/path0/pages/history.vue")
  },
  {
    name: "history___lu",
    path: "/lu/geschicht",
    component: () => import("/vercel/path0/pages/history.vue")
  },
  {
    name: "index___fr",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___lu",
    path: "/lu",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "jobs___fr",
    path: "/emplois",
    component: () => import("/vercel/path0/pages/jobs.vue")
  },
  {
    name: "jobs___en",
    path: "/en/jobs",
    component: () => import("/vercel/path0/pages/jobs.vue")
  },
  {
    name: "jobs___lu",
    path: "/lu/jobs",
    component: () => import("/vercel/path0/pages/jobs.vue")
  },
  {
    name: "particle-slug___fr",
    path: "/article/:slug()",
    component: () => import("/vercel/path0/pages/particle/[slug].vue")
  },
  {
    name: "particle-slug___en",
    path: "/en/article/:slug()",
    component: () => import("/vercel/path0/pages/particle/[slug].vue")
  },
  {
    name: "particle-slug___lu",
    path: "/lu/artikel/:slug()",
    component: () => import("/vercel/path0/pages/particle/[slug].vue")
  },
  {
    name: "platform___fr",
    path: "/plateforme",
    component: () => import("/vercel/path0/pages/platform.vue")
  },
  {
    name: "platform___en",
    path: "/en/platform",
    component: () => import("/vercel/path0/pages/platform.vue")
  },
  {
    name: "platform___lu",
    path: "/lu/plattform",
    component: () => import("/vercel/path0/pages/platform.vue")
  },
  {
    name: "privacy___fr",
    path: "/privacy",
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "privacy___lu",
    path: "/lu/privacy",
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "services___fr",
    path: "/services",
    component: () => import("/vercel/path0/pages/services.vue")
  },
  {
    name: "services___en",
    path: "/en/services",
    component: () => import("/vercel/path0/pages/services.vue")
  },
  {
    name: "services___lu",
    path: "/lu/d%C3%A9ngschter",
    component: () => import("/vercel/path0/pages/services.vue")
  },
  {
    name: "slice-simulator___fr",
    path: "/slice-simulator",
    component: () => import("/vercel/path0/pages/slice-simulator.vue")
  },
  {
    name: "slice-simulator___en",
    path: "/en/slice-simulator",
    component: () => import("/vercel/path0/pages/slice-simulator.vue")
  },
  {
    name: "slice-simulator___lu",
    path: "/lu/slice-simulator",
    component: () => import("/vercel/path0/pages/slice-simulator.vue")
  },
  {
    name: "team___fr",
    path: "/equipe",
    component: () => import("/vercel/path0/pages/team.vue")
  },
  {
    name: "team___en",
    path: "/en/team",
    component: () => import("/vercel/path0/pages/team.vue")
  },
  {
    name: "team___lu",
    path: "/lu/team",
    component: () => import("/vercel/path0/pages/team.vue")
  },
  {
    name: "testimonials____fr",
    path: "/testimonials_",
    component: () => import("/vercel/path0/pages/testimonials_.vue")
  },
  {
    name: "testimonials____en",
    path: "/en/testimonials_",
    component: () => import("/vercel/path0/pages/testimonials_.vue")
  },
  {
    name: "testimonials____lu",
    path: "/lu/testimonials_",
    component: () => import("/vercel/path0/pages/testimonials_.vue")
  },
  {
    name: "testimonials___fr",
    path: "/temoignages",
    component: () => import("/vercel/path0/pages/testimonials.vue")
  },
  {
    name: "testimonials___en",
    path: "/en/testimonials",
    component: () => import("/vercel/path0/pages/testimonials.vue")
  },
  {
    name: "testimonials___lu",
    path: "/lu/testimonials",
    component: () => import("/vercel/path0/pages/testimonials.vue")
  }
]